import script from "./M365Detail.vue?vue&type=script&setup=true&lang=js"
export * from "./M365Detail.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__